import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { segmentKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useCreateSegment = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('segments/create/'), body, additional),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: segmentKeys.all })
    });
};
export default useCreateSegment;
